import { render, staticRenderFns } from "./pos-login.vue?vue&type=template&id=23c13d21&scoped=true&"
import script from "./pos-login.vue?vue&type=script&lang=js&"
export * from "./pos-login.vue?vue&type=script&lang=js&"
import style0 from "./pos-login.vue?vue&type=style&index=0&id=23c13d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c13d21",
  null
  
)

export default component.exports